const DEFAULT_IMAGE_HOSTS = [
  'cdn.weatherapi.com',
  'firebasestorage.googleapis.com',
  'storage.googleapis.com',
];

const configuredImageHosts = readClientEnv('REACT_APP_ALLOWED_IMAGE_HOSTS')
  .split(',')
  .map(host => host.trim().toLowerCase())
  .filter(Boolean);

const imageHosts = new Set([...DEFAULT_IMAGE_HOSTS, ...configuredImageHosts]);

const isPrivateHostname = (hostname) => {
  const normalized = hostname.toLowerCase().replace(/^\[|\]$/g, '');
  if (
    normalized === 'localhost' ||
    normalized.endsWith('.localhost') ||
    normalized.endsWith('.local') ||
    normalized.endsWith('.internal') ||
    normalized === '::1' ||
    normalized === '0:0:0:0:0:0:0:1' ||
    normalized.startsWith('fc') ||
    normalized.startsWith('fd') ||
    /^fe[89ab]/.test(normalized)
  ) {
    return true;
  }

  const octets = normalized.split('.').map(Number);
  if (octets.length !== 4 || octets.some(octet => !Number.isInteger(octet) || octet < 0 || octet > 255)) {
    return false;
  }

  return (
    octets[0] === 10 ||
    octets[0] === 127 ||
    (octets[0] === 169 && octets[1] === 254) ||
    (octets[0] === 172 && octets[1] >= 16 && octets[1] <= 31) ||
    (octets[0] === 192 && octets[1] === 168) ||
    (octets[0] === 0)
  );
};

const parseHttpsUrl = (value, { allowRelative = false } = {}) => {
  if (typeof value !== 'string') return null;
  const candidate = value.trim();
  if (!candidate || candidate.length > 2048) return null;

  if (candidate.startsWith('/') && !candidate.startsWith('//')) {
    return allowRelative ? { href: candidate, hostname: null } : null;
  }

  const normalized = candidate.startsWith('//') ? `https:${candidate}` : candidate;
  try {
    const parsed = new URL(normalized);
    if (
      parsed.protocol !== 'https:' ||
      parsed.username ||
      parsed.password ||
      isPrivateHostname(parsed.hostname)
    ) {
      return null;
    }
    return { href: parsed.href, hostname: parsed.hostname.toLowerCase() };
  } catch (_error) {
    return null;
  }
};

const hostMatches = (hostname, allowedHost) => (
  hostname === allowedHost || hostname.endsWith(`.${allowedHost}`)
);

export const safeExternalUrl = (value) => parseHttpsUrl(value)?.href || null;

export const safeImageUrl = (value) => {
  const parsed = parseHttpsUrl(value, { allowRelative: true });
  if (!parsed) return null;
  if (parsed.hostname === null) return parsed.href;

  const allowed = [...imageHosts].some(host => hostMatches(parsed.hostname, host));
  return allowed ? parsed.href : null;
};
import { readClientEnv } from '../config/runtimeEnv';
